export default __webpack_public_path__ + "static/char-v-54-c5a1a7d104789c59b241b35351cf7360.png";